<div class="flex flex-col h-full w-full overflow-hidden p-2">
    <div class="flex flex-col sm:flex-row gap-2 w-full items-start sm:items-center flex-shrink-0">
        <!-- @if(filteredFiles.length > 0){ -->

        <div class="flex items-center gap-2 w-full sm:w-auto">
            <app-button label="Upload files" severity="primary" icon="pi pi-upload" (clicked)="uploadFile()"
                [enableThrottle]="true" class="w-full sm:w-auto" />
        </div>
        <div class="w-full sm:w-64 md:w-72 lg:w-80">
            <app-search-bar placeholder="Search" width="100%" [(ngModel)]="searchValue" (searchChange)="onSearch()">
            </app-search-bar>
        </div>
    </div>

    @if(filteredFiles.length > 0 && selectedFiles.length > 0){
    <div
        class="flex flex-col sm:flex-row gap-2 p-2 border rounded-base shadow-sm justify-between items-start sm:items-center flex-shrink-0 mb-2 sm:mb-3">
        <div class="flex flex-row flex-wrap items-center gap-2">
            <p class="text-sm sm:text-base">{{selectedFiles.length}} items selected</p>
            <div class="hidden sm:block h-6 w-px bg-gray-300 mx-2"></div>

            <app-button variant="outlined" icon="pi pi-download" (clicked)="downloadFiles()" [enableThrottle]="true" />

            <div class="hidden sm:block h-6 w-px bg-gray-300 mx-2"></div>

            <app-button variant="outlined" icon="pi pi-file-import" (clicked)="openLinkToKnowlegeBaseDialog()" />
        </div>

        <div class="flex flex-row items-center gap-2 w-full sm:w-auto justify-end">
            <app-button variant="outlined" severity="danger" icon="pi pi-trash" (clicked)="openDeleteDialogBox()" />
        </div>
    </div>
    }

    <div class="flex-1 min-h-0">
        <app-data-table [data]="filteredFiles" [columns]="tableColumns" [config]="tableConfig" [dataKey]="'_id'"
            [rowClass]="getRowClass" (selectionChange)="onSelectionChange($event)" tableClass="rounded-base text-sm"
            [customTemplates]="templatesMap" [customEmptyTemplate]="customEmptyRef">
        </app-data-table>
    </div>

    <!-- Template Definitions -->
    <!-- File Template -->
    <ng-template #fileTemplateRef let-file="$implicit">
        @if(file.type == 'FILE'){
        <div class="flex justify-between items-center gap-2 max-w-xs truncate">
            <div class="flex-shrink-0 w-7 h-7 flex items-center justify-center">
                @if(file.mimeType == "pdf"){
                <i [innerHTML]="SVGS.PDF | sanitizeHtml"></i>
                }@else if(file.mimeType == "docx"){
                <i [innerHTML]="SVGS.DOCX | sanitizeHtml"></i>
                }
            </div>
            <div class="flex items-center justify-between gap-2 flex-1 overflow-hidden">
                <span class="text-sm font-medium truncate" [pTooltip]="file.name">{{file.name}}</span>
                <app-status-badge [status]="file.documentKnowledge?.embeddingsStatus"></app-status-badge>
            </div>
        </div>
        }
    </ng-template>

    <!-- User Template -->
    <ng-template #userTemplateRef let-file="$implicit">
        <div class="flex items-center gap-1">
            <app-user-name-display [user]="file.createdBy" [variant]="'avatar-name'">
            </app-user-name-display>
        </div>
    </ng-template>

    <!-- Knowledge Base Template -->
    <ng-template #knowledgeBaseTemplateRef let-file="$implicit">
        <div class="flex flex-wrap gap-1 max-w-xs items-center">
            @if(file.knowledgeBases.length > 0) {
            @for(kb of file.knowledgeBases.slice(0, 2); track kb._id) {
            <span
                class="inline-block bg-blue-100 border border-blue-500 text-black text-xs px-2 py-1 rounded-lg font-medium">
                {{ kb.name }}
            </span>
            }
            @if(file.knowledgeBases.length > 2) {
            <app-popover>
                <ng-template #trigger>
                    <span
                        class="bg-slate-50 inline-block border border-gray-200 text-black text-xs px-2 py-1 rounded-full font-medium cursor-pointer hover:bg-gray-200 transition-colors">
                        +{{ file.knowledgeBases.length - 2 }}
                    </span>
                </ng-template>

                <ng-template #body>
                    <div class="flex flex-col gap-1 p-2">
                        @for(kb of getKnowledgeBasesForFile(file).slice(2); track kb._id) {
                        <div class="text-sm text-gray-800 truncate max-w-full" title="{{ kb.name }}">
                            {{ kb.name }}
                        </div>
                        }
                    </div>
                </ng-template>
            </app-popover>
            }
            } @else {
            <span class="text-gray-500 text-sm">N/A</span>
            }
        </div>
    </ng-template>

    <!-- Number of Times Used Template -->
    <ng-template #numberOfTimesUsedTemplateRef let-file="$implicit">
        <span class="text-xs text-gray-600">{{file.numberOfTimesUsed}}</span>
    </ng-template>

    <!-- Date Template -->
    <ng-template #dateTemplateRef let-file="$implicit">
        <div style="display: flex; align-items: center; gap: 4px;">
            <i [innerHTML]="SVGS.CALENDER_DAYS | sanitizeHtml" class="mb-0.5 w-4 h-4"></i>
            {{ file.createdAt | date:'dd/MM/yyyy' }}
        </div>
    </ng-template>

    <!-- Actions Template -->
    <ng-template #actionsTemplateRef let-file="$implicit">
        <div class="flex items-center justify-center" (click)="$event.stopPropagation()">
            <app-popover #menu width="14rem">
                <ng-template #trigger>
                    <i class="pi pi-ellipsis-v cursor-pointer icon-sm"></i>
                </ng-template>
                <ng-template #body>
                    <div class="flex flex-col text-sm">
                        <div (click)="openDocumentPreview(file); menu.hide()"
                            class="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors">
                            <i class="pi pi-eye text-sm"></i>
                            <span>View</span>
                        </div>
                        <div (click)="openLinkToKnowlegeBaseDialog(file); menu.hide()"
                            class="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors">
                            <i class="pi pi-link text-sm"></i>
                            <span>Link to knowledge base</span>
                        </div>
                        <div (click)="openDeleteDialogBox(file); menu.hide()"
                            class="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors text-danger">
                            <i class="pi pi-trash text-sm"></i>
                            <span>Delete</span>
                        </div>
                    </div>
                </ng-template>
            </app-popover>
        </div>
    </ng-template>

    <!-- Custom Empty Template -->
    <ng-template #customEmptyRef let-file="$implicit">
        @if(searchValue.trim()){
        <div class="text-center text-gray-500">
            <p class="text-lg">No files found matching "{{searchValue}}"</p>
            <p class="text-sm">Try adjusting your search terms or upload a new file</p>
        </div>
        }@else{
        <div class="flex flex-col justify-center items-center gap-4 py-8 min-h-[400px]">
            <div class="flex justify-center items-center flex-col">
                <div class="flex justify-center items-center">
                    <div class="relative">
                        <img class="align-middle" [src]="'images/upload-image.png' | assetUrl" alt="" width="200"
                            height="200" draggable="false">
                    </div>
                </div>
                <h1 class="text-lg font-semibold mt-3">Oops! your files are empty</h1>
                <p class="font-medium mt-2 text-gray-600 text-sm">Click on upload below to upload your document</p>
            </div>
            <app-button variant="filled" icon="pi pi-upload" (clicked)="uploadFile()" [enableThrottle]="true" />
        </div>
        }
    </ng-template>
</div>

<app-dialog [(visible)]="linkToKnowledgeBaseDialog" title="Link to Knowledge Base"
    (closed)="linkToKnowledgeBaseDialog = false" class="max-w-[800px]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-2 w-full p-4">
            <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full">
                <div class="flex-1">
                    <app-search-bar placeholder="Search here" width="100%" [(ngModel)]="knowledgeBaseSearchValue"
                        (searchChange)="onKnowledgeBaseSearch()">
                    </app-search-bar>
                </div>
                <div class="flex-shrink-0 w-full sm:w-auto">
                    <app-button variant="outlined" icon="pi pi-plus" (clicked)="createNewKnowledgeBase()"
                        class="w-full sm:w-auto" />
                </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-2 max-h-[60vh] overflow-y-auto">
                @for(knowledgeBase of filteredKnowledgeBases; track knowledgeBase._id){
                <div class="flex flex-row gap-2 p-2 border rounded-2xl shadow-sm cursor-pointer hover:bg-gray-50 transition-colors"
                    (click)="toggleKnowledgeBaseSelection(knowledgeBase)">
                    <div class="flex flex-row gap-2 justify-between items-center w-full">
                        <div class="flex items-center gap-2 flex-1 min-w-0">
                            <app-checkbox [value]="knowledgeBase.isSelected" [config]="{ binary: true }"
                                class="rounded-full" />
                            <i [innerHTML]="SVGS.FOLDER | sanitizeHtml" alt="" width="30" height="30"></i>
                            <div class="flex flex-col min-w-0 flex-1">
                                <span class="text-sm font-medium truncate">{{knowledgeBase.name}}</span>
                                <span class="text-xs text-gray-500 line-clamp-2">{{knowledgeBase.description}}</span>
                            </div>
                        </div>
                        <div class="flex flex-col justify-end items-end flex-shrink-0">
                            <p class="text-xs sm:text-sm font-medium whitespace-nowrap">{{knowledgeBase.files.length}}
                                files</p>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex flex-col sm:flex-row justify-end gap-2">
            <app-button variant="outlined" label="Cancel" severity="contrast" icon="pi pi-times"
                (clicked)="linkToKnowledgeBaseDialog = false" class="w-full sm:w-auto" />
            <app-button variant="filled" severity="primary" label="Link to Selected" icon="pi pi-link"
                (clicked)="linkToKnowledgeBase()" [enableThrottle]="true" class="w-full sm:w-auto" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="createNewKnowledgeBaseDialog" title="Create Knowledge Base Store"
    (closed)="createNewKnowledgeBaseDialog = false" class="max-w-[500px]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-2 p-4">
            <form [formGroup]="knowledgeBaseForm">
                <div class="flex flex-col align-items-center gap-1 mb-3">
                    <label for="name" class="w-full text-sm sm:text-base">
                        Name<span class="text-danger">*</span>
                    </label>
                    <input id="name" name="name" formControlName="name"
                        class="w-full border outline-none rounded-base input p-2" placeholder="" autocomplete="off"
                        required />
                    <div *ngIf="knowledgeBaseForm.controls['name'].invalid && (knowledgeBaseForm.controls['name'].dirty)"
                        class="text-danger text-xs w-full">
                        {{"Name is required." | titlecase}}
                    </div>
                </div>
                <div class="flex flex-col align-items-center gap-1 mb-3">
                    <label for="description" class="w-full text-sm sm:text-base">
                        Description<span class="text-danger">*</span>
                    </label>
                    <textarea id="description" name="description" formControlName="description"
                        class="w-full border outline-none rounded-base input p-2" placeholder="Type Here"
                        autocomplete="off" required rows="4"></textarea>
                    <div *ngIf="knowledgeBaseForm.controls['description'].invalid && (knowledgeBaseForm.controls['description'].dirty)"
                        class="text-danger text-xs w-full">
                        {{"Description is required." | titlecase}}
                    </div>
                </div>
            </form>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex flex-col sm:flex-row justify-end gap-2">
            <app-button variant="outlined" label="Cancel" severity="contrast" icon="pi pi-times"
                (clicked)="createNewKnowledgeBaseDialog = false" class="w-full sm:w-auto" />
            <app-button variant="filled" severity="primary" label="Add" icon="pi pi-plus"
                (clicked)="createKnowledgeBaseStore()" [enableThrottle]="true" class="w-full sm:w-auto" />
        </div>
    </ng-template>
</app-dialog>

@if(deleteFileFromKnowledgeBase){
<app-delete-confirmation [(visible)]="deleteFileFromKnowledgeBase" confirmButtonText="Yes, Delete"
    (onConfirm)="fileToBeDeleted ? deleteFile(fileToBeDeleted) : deleteSelectedFiles()"
    (onCancel)="deleteFileFromKnowledgeBase = false">

    <ng-template #headerTemplate>
        <span class="flex items-center gap-2 text-lg">
            <i [innerHTML]="SVGS.RED_TRASH | sanitizeHtml" style="cursor: pointer;"></i>
            <ng-container *ngIf="fileToBeDeleted; else deleteMultipleHeader">
                <span class="font-bold">Delete the file?</span>
            </ng-container>
            <ng-template #deleteMultipleHeader>
                <span class="font-bold">Delete {{selectedFiles.length}} files?</span>
            </ng-template>
        </span>
    </ng-template>

    <ng-template #bodyTemplate>
        <ng-container *ngIf="fileToBeDeleted; else deleteMultipleBody">
            <p class="text-sm text-gray-700">
                This file will be permanently deleted from the repository. If you only want to remove it from this
                knowledge base, please click on 'Delink' instead. Do you want to proceed with deleting this file?
            </p>
        </ng-container>
        <ng-template #deleteMultipleBody>
            <p class="text-sm text-gray-700">
                Selected files will be permanently deleted from the files. If you only want to remove it from this
                knowledge base, please click on 'Delink' instead.
            </p>
        </ng-template>
    </ng-template>
</app-delete-confirmation>
}

<app-dialog [(visible)]="showDocumentPreview" [title]="selectedFile?.name ?? ''" (closed)="closeDocumentPreview()"
    class="max-w-4xl h-[90vh]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="h-full w-full">
            @if(selectedDocumentFile && selectedDocumentId) {
            <app-document-preview [documentId]="selectedDocumentId" [file]="selectedDocumentFile">
            </app-document-preview>
            }
        </div>
    </ng-template>
</app-dialog>